import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
// const smsCampaign = RepositoryFactory.smsCampaign;

export default {
  addMultipleAudience({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.audience.addMultipleAudience(
          payload
        );

        commit("ADD_MULTIPLE_AUDIENCE", { key: "members", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
